'use client'

import 'dayjs/locale/pt-br'

export function DatesLocale() {
	return <></>
}
